/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var Permission;
(function (Permission) {
    Permission["AllPermissions"] = "ALL_PERMISSIONS";
    Permission["CreateUser"] = "CREATE_USER";
    Permission["ReadUser"] = "READ_USER";
    Permission["UpdateUser"] = "UPDATE_USER";
    Permission["DeleteUser"] = "DELETE_USER";
    Permission["CreateOrganisation"] = "CREATE_ORGANISATION";
    Permission["ReadOrganisation"] = "READ_ORGANISATION";
    Permission["SwitchToOrganisation"] = "SWITCH_TO_ORGANISATION";
    Permission["UpdateOrganisation"] = "UPDATE_ORGANISATION";
    Permission["DeleteOrganisation"] = "DELETE_ORGANISATION";
    Permission["AdministerOrganisation"] = "ADMINISTER_ORGANISATION";
    Permission["AccessNetwork"] = "ACCESS_NETWORK";
    Permission["CreateNetwork"] = "CREATE_NETWORK";
    Permission["ReadNetwork"] = "READ_NETWORK";
    Permission["UpdateNetwork"] = "UPDATE_NETWORK";
    Permission["DeleteNetwork"] = "DELETE_NETWORK";
    Permission["CreateLocation"] = "CREATE_LOCATION";
    Permission["ReadLocation"] = "READ_LOCATION";
    Permission["UpdateLocation"] = "UPDATE_LOCATION";
    Permission["DeleteLocation"] = "DELETE_LOCATION";
    Permission["CreatePlayer"] = "CREATE_PLAYER";
    Permission["ConfirmPlayer"] = "CONFIRM_PLAYER";
    Permission["ReadPlayer"] = "READ_PLAYER";
    Permission["UpdatePlayer"] = "UPDATE_PLAYER";
    Permission["DeletePlayer"] = "DELETE_PLAYER";
    Permission["CreateTag"] = "CREATE_TAG";
    Permission["ReadTag"] = "READ_TAG";
    Permission["UpdateTag"] = "UPDATE_TAG";
    Permission["DeleteTag"] = "DELETE_TAG";
    Permission["CreateCampaign"] = "CREATE_CAMPAIGN";
    Permission["ReadCampaign"] = "READ_CAMPAIGN";
    Permission["UpdateCampaign"] = "UPDATE_CAMPAIGN";
    Permission["DeleteCampaign"] = "DELETE_CAMPAIGN";
    Permission["CreateContent"] = "CREATE_CONTENT";
    Permission["ReadContent"] = "READ_CONTENT";
    Permission["UpdateContent"] = "UPDATE_CONTENT";
    Permission["DeleteContent"] = "DELETE_CONTENT";
    Permission["ReleaseContent"] = "RELEASE_CONTENT";
    Permission["CreateRole"] = "CREATE_ROLE";
    Permission["ReadRole"] = "READ_ROLE";
    Permission["UpdateRole"] = "UPDATE_ROLE";
    Permission["DeleteRole"] = "DELETE_ROLE";
    Permission["GrantAccess"] = "GRANT_ACCESS";
    Permission["CreateAccessGrant"] = "CREATE_ACCESS_GRANT";
    Permission["ReadAccessGrant"] = "READ_ACCESS_GRANT";
    Permission["UpdateAccessGrant"] = "UPDATE_ACCESS_GRANT";
    Permission["DeleteAccessGrant"] = "DELETE_ACCESS_GRANT";
    Permission["ReadApiDocs"] = "READ_API_DOCS";
})(Permission || (Permission = {}));
export function PermissionFromJSON(json) {
    return PermissionFromJSONTyped(json, false);
}
export function PermissionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function PermissionToJSON(value) {
    return value;
}
